{
  "nl": {
    "proposal": {
      "actions": {
        "addDescription": "Voeg omschrijving toe",
        "addDocuments": "Voeg document toe",
        "addSubchoiceList": "Subkeuzelijst",
        "addSubchoices": "Subkeuze",
        "approve": "Aanvaarden",
        "cancel": "Annuleer",
        "choice": {
          "collapse": "Sluit keuzes",
          "delete": "Verwijder keuze",
          "edit": "Pas keuze aan",
          "expand": "Open keuzes"
        },
        "choice_list": {
          "delete": "Verwijder keuzelijst"
        },
        "createNew": "Nieuw voorstel",
        "deleteDescription": "Verwijder omschrijving",
        "deleteDocuments": "Verwijder document",
        "delete_documents": "Verwijder document | Verwijder documenten",
        "delete_proposal": "Verwijder voorstel",
        "delete_proposal_templates": "Voorstelsjabloon verwijderen",
        "dontShare": "Nog niet nodig om te delen",
        "duplicate": "Dupliceren",
        "edit": "Bewerken",
        "generatePDF": "Genereer PDF",
        "new": "Voorstel",
        "newProposalCustomer": "Nieuw voorstel",
        "publish": "Publiceer",
        "reject": "Aanvaarding ongedaan maken",
        "save": "Opslaan",
        "share": "Deel",
        "shareWithProjectPartners": "Documenten delen met projectpartners...",
        "share_units": "Deel met units",
        "signAndApprove": "Onderteken en aanvaard voorstel",
        "signElectronically": "Of plaats elektronische handtekening",
        "steps": {
          "collapse": "Sluit stappen",
          "expand": "Open stappen"
        },
        "stop_template_sync": "Stop synchronisatie met sjabloon",
        "submit": "Opslaan",
        "uploadAndApprove": "Upload en aanvaard voorstel",
        "uploadSignableDocument": "Ondertekend document uploaden voor aanvaarding"
      },
      "attributes": {
        "amount_gross": "Bruto offerte",
        "amount_net": "Netto offerte",
        "choice_lists": {
          "description": "Omschrijving",
          "name": "Naam"
        },
        "choices": {
          "description": "Omschrijving",
          "images": "Afbeeldingen",
          "name": "Naam",
          "price_gross": "Bruto itemprijs",
          "price_net": "Netto itemprijs",
          "quantity": "Hoeveelheid",
          "quantity_fixed": "Vast aantal",
          "quantity_max": "Maximum",
          "quantity_min": "Minimum",
          "quantity_not_fixed": "Laat klant aantal invullen",
          "selected_default": "Altijd geselecteerd",
          "total_price_gross": "Totale prijs bruto",
          "total_price_net": "Totaal netto"
        },
        "description": "Omschrijving",
        "documents": "Documenten",
        "name": "Naam",
        "subtitle": "Dit maakt het gemakkelijk voor anderen om naar te refereren",
        "title": "Titel",
        "type": {
          "choices": "Keuzelijst",
          "fixed": "Vast voorstel"
        },
        "vat_percentage": "BTW %"
      },
      "labels": {
        "accepted": "Aanvaard",
        "addExtraBudget": "Extra budget toevoegen",
        "amount_net_total": "Totale netto offerte",
        "amount_total": "Totale offerte",
        "approve": "Aanvaard {name}",
        "approved": "Aanvaard",
        "approvedDate": "Aanvaard op {date}",
        "ask_client_to_undo": "Je kan dit goedgekeurd voorstel niet bewerken. Neem contact op met {client} om eerst de goedkeuring ongedaan te maken.",
        "batchProposalsTemplate": "<p>Dit voorstel wordt gemaakt voor {units_count} unit(s).</p></br><p>Omdat dit voorstel voor meerdere units wordt gemaakt, hebben we er een voorstelsjabloon van gemaakt. Je vindt dit voorstelsjabloon onder het tabblad 'Voorstelsjablonen'.</p></br><p>Sjablonen maken het eenvoudiger om alle voorstellen die met dit sjabloon zijn gesynchroniseerd, te bewerken of te verwijderen.</p>",
        "batchProposalsWarning": "Ditzelfde voorstel zal aangemaakt worden voor {units_count} units. Indien je later iets wilt wijzigen, dient dat voor elk voorstel afzonderlijk te gebeuren.",
        "budget": "Budget",
        "builder": {
          "can_select_multiple": "Kan meerdere selecteren",
          "item": "Keuze",
          "multiple_choices_possible": "Meerdere keuzes mogelijk",
          "must_choose_item": "Verplicht keuze te maken",
          "options": "Keuzes",
          "section": "Keuzelijst",
          "step": "Stap",
          "step_basic": "Basisinformatie",
          "step_details": "Details",
          "step_documents": "Documenten",
          "step_internal": "Interne informatie",
          "step_visibility": "Deel met"
        },
        "by": "door",
        "choice_lists": {
          "add_another": "Voeg nieuwe keuzelijst toe",
          "create": "Maak keuzelijsten aan",
          "empty_help": "Begin met het toevoegen van uw eerste keuzenlijst(en). Keuzelijsten groeperen keuzes voor een specifiek item, bijv. vloertegels. Nadat u keuzenlijsten heeft toegevoegd, kunt u een of meer keuzes toevoegen.",
          "selected": "Geselecteerd"
        },
        "choices": {
          "add_another": "Voeg nog een keuze toe",
          "create": "Voeg keuzes toe aan {choiceListName}",
          "optional": "Optioneel",
          "selected_default": "Deze keuze zal altijd geselecteerd zijn en de prijs zal automatisch verrekend worden in de totale prijs. De klant zal deze keuze niet kunnen deselecteren.",
          "subtotal": "Subtotaal"
        },
        "closed": "Deze beslissing is nu gesloten. Je kan geen voorstel meer goedkeuren.",
        "createProposal": "Maak een voorstel",
        "createProposals": "Maak voorstel aan",
        "createdBy": "Aangemaakt door {uploader}",
        "customer": "Klant",
        "customerHasNotSelectedYet": "Klant heeft nog niet geselecteerd",
        "customer_name_confirm": "Typ <i><b>{customerName}</b></i> neer om dit voorstel te aanvaarden.",
        "customer_name_proceed": "Gelieve <i><b>{customerName}</b></i> te typen om verder te gaan.",
        "customer_offer": "Offerte klant",
        "customers": "Klanten",
        "definedPerUnit": "Gedefinieerd per unit",
        "delete_proposal_template": "<p>Als je dit sjabloon verwijdert, worden ook alle gesynchroniseerde voorstellen verwijderd.<br>Als je niet wilt dat dit gebeurt, gebruik je de onderstaande knop.</p>",
        "depends_on_customer_input": "Hangt af van input van klant",
        "documentsRequireSignature": "Klant moet documenten ondertekenen",
        "documents_shared_partners": "Alleen documenten van het voorstel worden gedeeld met projectpartners.",
        "duplicating": "Aan het dupliceren",
        "edit": "Bewerk",
        "editNotAllowed": "Een aanvaard voorstel bewerken of verwijderen is niet toegestaan. Maak eerst de aanvaarding ongedaan voordat je deze bewerkt.",
        "editProposal": "Bewerk voorstel",
        "excl%VAT": "excl. {vat}% BTW",
        "exclVAT": "excl. btw",
        "export_documents": "Exporteer documenten",
        "extraBudget": "Extra budget",
        "fractions_sent_count_header": "Kan geen voorstel maken!",
        "fractions_sent_count_message": "Betaalschijven op basis van deze beslissing zijn al verzonden. Plaats deze betaalschrijven eerst in draft om door te gaan.",
        "full_prices": "Gebruik volledige prijzen. Ziggu zal automatisch meerprijzen genereren op basis van het budget.",
        "generatingPDF": "Pdf wordt gegenereerd",
        "hideDetails": "Details verbergen",
        "internalNote": "Interne notitie",
        "internalNoteSubtitle": "Deze notitie is alleen zichtbaar voor jou en jouw team.",
        "internal_info": "Interne informatie",
        "keepHidden": "Verborgen houden",
        "keep_synced_proposals": "Bewaar gesynchroniseerde voorstellen zodat ze op zichzelf zullen blijven bestaan.",
        "link_to_template": "Link naar sjabloon?",
        "link_to_template_after_create": "Koppel dit voorstel direct na aanmaak aan het nieuwe sjabloon.",
        "makeDecision": "Accepteer een voorstel voor {decision_name} door op de goedkeuringsknop te klikken",
        "margin": "Marge",
        "marginBudget%": "Marge budget ({margin}%)",
        "marginSurcharge%": "Marge meerwerken ({margin}%)",
        "marginSurchargesExtraBudget%": "Marge extra budget + meerwerken ({margin}%)",
        "new": "Nieuw voorstel",
        "noImage": "Geen afbeelding aanwezig",
        "no_budget_available_yet": "Niet van toepassing",
        "no_documents": "Dit voorstel bevat geen documenten.",
        "no_edit_details": "Dit voorstel heeft elementen die ervan afhangen. Neem contact op met de klant als u details wilt bewerken",
        "no_edit_details_installments": "Dit voorstel heeft minstens één gefactureerde of betaalde betaalschijf. Om de voorsteldetails te wijzigen, moet u eerste de status van deze betaalschijf naar 'Verwacht' zetten. Ga naar {link}.",
        "no_edit_details_installments_link": "financieel",
        "no_edit_documents": "Als een voorstel geaccepteerd is kunnen documenten niet meer aangepast worden.",
        "notApplicable": "Niet van toepassing",
        "notDefined": "Niet gedefinieerd",
        "notSeenYetByCustomer": "Nog niet gezien door de klant",
        "notSelectedYet": "Selecteer uw keuzes om het totaal te zien",
        "notSharedYet": "Nog niet gedeeld",
        "not_interested_reset_header": "Beslissing gemarkeerd als niet geïnteresseerd",
        "not_interested_reset_message": "Deze beslissing is momenteel gemarkeerd als 'Niet geïnteresseerd'. Het aanmaken van een voorstel zal de status 'Niet geïnteresseerd' resetten.",
        "only_visible_team_partners": "Enkel zichtbaar voor het team",
        "other": "Andere",
        "proposalFor": "Voorstel voor",
        "proposal_template_sync_note": "Wijzigingen aanbrengen aan een voorstelsjabloon wijzigt alle gesynchroniseerde en niet-goedgekeurde voorstellen ook.",
        "proposalsApproved": "Aanvaarde voorstellen",
        "proposalsOther": "Andere voorstellen",
        "relaunch": "Voorstel opnieuw lanceren",
        "request_changes": {
          "body": "Geef wat aanvullende feedback over wat er in dit voorstel moet worden gewijzigd",
          "feedback": "Feedback",
          "title": "Wijzigingen aanvragen"
        },
        "requested_changes": "Wijzigingen gevraagd",
        "requiresSignature": "Moet documenten ondertekenen",
        "seenByCustomer": "Gezien door de klant:",
        "selectUnitsShare": "Selecteer de units waarmee je het sjabloon wilt delen",
        "shareCustomerDescription": "Dit voorstel is gekoppeld aan een beslissing die nog niet is gedeeld met de klant. Wilt u de beslissing ook delen zodat de klant dit voorstel meteen kan zien?",
        "shareCustomerTitle": "Beslissing delen met klant?",
        "shareDecision": "Beslissing delen",
        "shareExtraAlert": "De beslissing wordt ook gedeeld zodra je op opslaan klikt",
        "sharePartnerTitle": "Beslissing delen met partner?",
        "sharePartnersDescription": "Dit voorstel is gekoppeld aan een beslissing die nog niet is gedeeld met de partner. Wilt u de beslissing ook delen zodat de partner dit voorstel meteen kan zien?",
        "sharedWith": "Gedeeld met",
        "showAndEditDetails": "Details weergeven en bewerken",
        "single_approval_warning": {
          "message": "Neem contact op met Ziggu om goedkeuring van meerdere voorstellen in te schakelen.",
          "title": "Je kunt voorstellen blijven aanmaken, maar de klant kan slechts één voorstel goedkeuren."
        },
        "surcharges": "Meerwerken",
        "surcharges_extra": "Extra meerwerken",
        "synced_with_template": "Gesynchroniseerd met voorstelsjabloon",
        "synced_with_units": "Gesynchroniseerd met 1 unit | Gesynchroniseerd met {unit_count} units",
        "template_accept_confirm": "<p>Dit voorstel is gesynchroniseerd met een voorstelsjabloon. Wanneer je dit voorstel aanvaardt, stopt de synchronisatie en wordt dit voorstel niet meer bijgewerkt wanneer de voorstelsjabloon wordt bijgewerkt.</p></br> <p>Weet je zeker dat je dit voorstel wilt aanvaarden?</p>",
        "template_edit_confirm": "<p>Dit voorstel is gesynchroniseerd met een voorstelsjabloon. Wanneer je dit voorstel bewerkt, stopt de synchronisatie en wordt dit voorstel niet meer bijgewerkt wanneer de voorstelsjabloon wordt bijgewerkt.</p></br> <p>Weet je zeker dat je dit voorstel wilt bewerken?</p>",
        "totalBudget": "Totaal budget",
        "totalNetOffer": "Netto offerte",
        "total_excl_vat": "Totaal excl. BTW",
        "total_incl_vat": "Totaal incl. BTW",
        "total_vat": "Totaal BTW",
        "typeToShare": "Type voorstel om te delen",
        "uploadDocuments": "Upload ondertekende documenten",
        "uploadSignedDocument": "Of upload ondertekende documenten",
        "vat_excl": "excl. BTW",
        "vat_excl_with_number": "excl. {vat} BTW%",
        "visibleForCustomer": "Zichtbaar voor de klant",
        "writeEmployeeNameAccept": "Typ <i><b>{employeeName}</b></i> neer om dit voorstel te aanvaarden.",
        "writeEmployeeNameDelete": "Typ <i><b>{employeeName}</b></i> neer om dit voorstel te verwijderen.",
        "writeEmployeeNameReject": "Typ <i><b>{employeeName}</b></i> neer om de aanvaarding ongedaan te maken."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Binnenkort vind je hier voorstellen om goed te keuren",
            "title": "Er zijn nog geen voorstellen voor {decision_name}"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Stel één of meerdere voorstellen op en laat de klant beslissen.",
            "title": "Maak een voorstel aan"
          },
          "proposalNotice": "Belangrijk: slechts 1 voorstel kan worden goedgekeurd. Je kan altijd een bestaand voorstel bewerken en nieuwe documenten toevoegen indien nodig.",
          "template": {
            "subtitle": "Als je voorstellen in bulk aanmaakt dan zullen ze hier zichtbaar zijn.",
            "title": "Er zijn nog geen voorstelsjablonen aangemaakt."
          }
        },
        "partners": {
          "new": {
            "subtitle": "Stel één of meerdere voorstellen op.",
            "title": "Maak een voorstel aan"
          },
          "proposalNotice": "Belangrijk: slechts 1 voorstel kan worden goedgekeurd. Je kan altijd een bestaand voorstel bewerken en nieuwe documenten toevoegen indien nodig."
        }
      },
      "toasts": {
        "convert": "Voorstel succesvol omgezet in sjabloon",
        "create": "Voorstel succesvol aangemaakt",
        "delete": "Voorstel succesvol verwijderd",
        "shareSuccess": "Voorstellen successvol gedeeld",
        "update": "Voorstel succesvol gewijzigd"
      },
      "validation": {
        "amountNotUpdatable": "Bedrag kan niet bewerkt worden. Sommige betalingsschijven hangen hier van af",
        "choice_list": {
          "needChoice": "Deze keuzelijst heeft minimaal 1 keuze nodig",
          "needSelection": "Deze keuzelijst vereist een geselecteerde keuze"
        },
        "choices": {
          "lessThanOrEqual": "Getal moet kleiner of gelijk zijn dan {max_number}",
          "needPriceItem": "Prijs per stuk is vereist",
          "needSelection": "Keuze vereist",
          "needVatPercentage": "BTW-percentage is vereist",
          "quantityBetween": "Aantal moet tussen {quantity_min} en {quantity_max} liggen",
          "quantityNotZero": "Aantal moet minimaal 1 zijn",
          "quantityRequired": "Hoeveelheid vereist",
          "uniqueNames": "Namen moeten uniek zijn"
        },
        "nameNotCorrect": "Naam is verplicht en moet overeenkomen",
        "needName": "Titel is vereist",
        "needNumber": "Moet een nummer zijn (bv 85)",
        "need_request_changes_note": "Geef feedback over uw wijzigingsverzoek",
        "readAllDocuments": "Zorg ervoor dat je alle documenten hebt gelezen",
        "requiresSignature": "Duid op minimaal 1 document aan waar de klant elektronisch moet ondertekenen. Schakel de onderstaande schakelaar uit als je geen handtekening nodig hebt.",
        "share": {
          "needSelection": "Selecteer iemand om het voorstel met te delen | Selecteer iemand om de voorstellen met te delen",
          "needType": "Selecteer het type voorstel"
        },
        "uploadAtLeast1Document": "Upload minimaal 1 ondertekend document"
      }
    }
  }
}
